// Terms and conditions checkbox functionality
document.addEventListener('DOMContentLoaded', function() {
  const termsCheckbox = document.getElementById('terms-checkbox');
  const termsCheckboxDrawer = document.getElementById('terms-checkbox-drawer');
  const checkoutButton = document.getElementById('checkout');
  const drawerCheckoutButton = document.getElementById('CartDrawer-Checkout');

  function updateCheckoutButton(checkbox, button) {
    if (checkbox && button) {
      button.disabled = !checkbox.checked;
      if (!checkbox.checked) {
        button.style.opacity = '0.5';
        button.style.cursor = 'not-allowed';
      } else {
        button.style.opacity = '1';
        button.style.cursor = 'pointer';
      }
    }
  }

  if (termsCheckbox && checkoutButton) {
    termsCheckbox.addEventListener('change', function() {
      updateCheckoutButton(termsCheckbox, checkoutButton);
    });
    // Initial state
    updateCheckoutButton(termsCheckbox, checkoutButton);
  }

  if (termsCheckboxDrawer && drawerCheckoutButton) {
    termsCheckboxDrawer.addEventListener('change', function() {
      updateCheckoutButton(termsCheckboxDrawer, drawerCheckoutButton);
    });
    // Initial state
    updateCheckoutButton(termsCheckboxDrawer, drawerCheckoutButton);
  }
}); 